/* eslint-disable import/no-unresolved */
import { atom, useRecoilValue } from 'recoil';
export const postalCodesMap = atom({
  key: 'postalCodesMap',
  default: new Map()
});
export default function usePostalCodes() {
  const map = useRecoilValue(postalCodesMap);
  return {
    map
  };
}